import { render, staticRenderFns } from "./FormatAlignLeft.vue?vue&type=template&id=1806513e"
import script from "./FormatAlignLeft.vue?vue&type=script&lang=js"
export * from "./FormatAlignLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports